import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { LanguageService } from '../core/language';

@Component({
  selector: 'app-accounts',
  imports: [RouterLink],
  templateUrl: './accounts.html',
})
export class AccountsPage {
  protected readonly auth = inject(AuthService);
  protected readonly lang = inject(LanguageService);
  protected readonly tiers = computed(() => [
    { name: this.lang.t('accClassic'), from: '$250', tone: 'classic', line: this.lang.t('accClassicLine'), mark: 'SPY' },
    { name: this.lang.t('accSilver'), from: '$2,500', tone: 'silver', line: this.lang.t('accSilverLine'), mark: 'ETH' },
    { name: this.lang.t('accGold'), from: '$10,000', tone: 'gold', line: this.lang.t('accGoldLine'), mark: 'XAU' },
    { name: this.lang.t('accPlat'), from: '$50,000', tone: 'platinum', line: this.lang.t('accPlatLine'), mark: 'NVDA' },
    { name: this.lang.t('accVip'), from: '$100,000', tone: 'vip', line: this.lang.t('accVipLine'), mark: 'BTC' },
  ]);
}
